<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<p-dialog #importproduct id="importproduct"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '75vw', height: '50hw'}">

  <ng-template pTemplate="content">
    <p-messages text="noTemplateMessage" severity="warn" *ngIf="!newProductTemplate"></p-messages>
    <div class="grid formgrid fluid">
      <p-accordion [multiple]="true" class="col">
        <p-accordionTab [selected]="openFileSelector">
          <ng-template pTemplate="header">
            <h5>Источник данных</h5>
          </ng-template>
          <p-tabView class="mt-2" [(activeIndex)]="tabIndex" (onChange)="onTabChange($event)" appStopAccordionHomeEnd>
            <p-tabPanel header="Выбор документа" [cache]="false" [disabled]="false">
              <ng-template pTemplate="header">
                <i class="pi pi-plus mr-2"></i>
                <span>Загрузка из файла</span>
              </ng-template>
              <div class="col-6 sm:col-12 mt-2 mr-2">
                <input type="file" (change)="onFileChange($event)" accept=".xls,.xlsx" [multiple]="false" />
              </div>
            </p-tabPanel>

            <p-tabPanel [cache]="false">
              <ng-template pTemplate="header">
                <i class="pi pi-sitemap mr-2"></i>
                <h5>Вставка из буфера копирования</h5>
              </ng-template>
              <textarea pInputTextarea [(ngModel)]="textSource" class="col-12" [style]="{height: '150px'}"></textarea>

              <div class="grid p-jc-between">
                <div class="col-2 mt-2">
                  <p-radioButton name="groupname" value="tab" label="TAB разделители" [(ngModel)]="textType" (onClick)="onTextTypeClick($event)"></p-radioButton>
                </div>
                <div class="col-2 mt-2">
                  <p-radioButton name="groupname" value="csv" label="CSV файл" [(ngModel)]="textType" (onClick)="onTextTypeClick($event)"></p-radioButton>
                </div>

                <div class="col-4 mt-2"></div>

                <p-button label="Вставить данные" (onClick)="onInsertText($event)" class="mt-2 mb-2 mr-2" [disabled]="!canInsertTextData"></p-button>
              </div>

            </p-tabPanel>
          </p-tabView>
        </p-accordionTab>

        <p-accordionTab [selected]="openFieldSelector">
          <ng-template pTemplate="header">
            <h5>Сопоставление полей</h5>
          </ng-template>
          <div class="grid formgrid fluid" appStopAccordionHomeEnd>

            <div class="col-2 xl:col-2 md:col-4 sm:col-6 mb-2" *ngFor="let fld of paramsMap">
              <h5>{{fld.fieldLabel}}</h5>
              <div class="flex">
                <div class="flex-auto">
                  <p-dropdown id="{{fld.fieldName}}"
                              [options]="columns"
                              [(ngModel)]="fld.importColumnName"
                              [showClear]="!fld.fieldIsMandatory"
                              [autofocusFilter]="false"
                              [autoDisplayFirst]="false"
                              [required]="fld.fieldIsMandatory"
                              (onClear)="onCleanFieldSelection($event, fld)"
                              (onChange)="onFieldSelectionClick($event, fld)"
                              pTooltip="Выбрать стобец для поля {{fld.fieldName}}" tooltipPosition="top"
                              ></p-dropdown>
                </div>
                <div class="flex ml-1">
                  <p-checkbox [(ngModel)]="fld.updateExisted" [binary]="true" id="cb-{{fld.fieldName}}" [disabled]="fld.importColumnName == ''" pTooltip="Обновлять существующие значения" tooltipPosition="top"></p-checkbox>
                </div>
              </div>
            </div>

            <div class="col-2 xl:col-2 sm:col-3 mb-2" *ngIf="processDateField">
              <h5>Обработка даты: {{selectedDateProcess}}</h5>
              <div class="fluid">
                <p-dropdown [options]="dateProcessType" [autofocusFilter]="false" [(ngModel)]="selectedDateProcess"></p-dropdown>
              </div>
            </div>
          </div>

          <p-table #sourceTable id="sourceTable"
                   appStopAccordionHomeEnd
                   [columns]="columns"
                   [value]="dataSource"
                   [paginator]="true"
                   [rows]="10"
                   [showCurrentPageReport]="true"
                   [resizableColumns]="true"
                   styleClass="p-datatable p-datatable-sm p-datatable-gridlines p-datatable-striped mt-2 mb-2">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" pResizableColumn
                    [class.met]="columnMet(col)"
                    style="width: auto; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                  {{col}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td *ngFor="let col of columns"
                    [class.met]="!hasWarningsOrErrors(rowData) && columnMet(col)"
                    [class.hasWarningsOrErrors]="hasWarningsOrErrors(rowData)"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                  {{rowData[col]}}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="col-12 grid mt-2" appStopAccordionHomeEnd>
            <div class="p-field-checkbox col-3 ">
              <p-checkbox [(ngModel)]="createNewOnly" [binary]="true" inputId="cno"></p-checkbox>
              <label for="shc">Вставить только новые</label>
            </div>
            <div class="p-field-checkbox col-3 ">
              <p-checkbox [(ngModel)]="clearBefore" [binary]="true" inputId="shc"></p-checkbox>
              <label for="shc">Очистить существующие</label>
            </div>
            <div class="p-field-checkbox col-3">
              <p-checkbox [(ngModel)]="overwriteExisted" [binary]="true" inputId="shd"></p-checkbox>
              <label for="shd">Обновлять существующие</label>
            </div>
            <div class="p-field-checkbox col-3">
              <p-checkbox [(ngModel)]="addExisted" [binary]="true" inputId="shi"></p-checkbox>
              <label for="shi">Добавлять к существующим</label>
            </div>
          </div>

          <div class="grid formgrid justify-content-end">
            <p-button label="Очистить все" (onClick)="onCleanAllClick($event)" class="mt-2 mb-2 mr-2" severity="warning" pTooltip="Отменить сопоставление полей" tooltipPosition="top"></p-button>
            <p-button label="Отменить все" (onClick)="onCancelAllClick($event)" class="mt-2 mb-2 mr-2" severity="warning" pTooltip="Убрать все 'Обновлять существующие значения'" tooltipPosition="top"></p-button>
            <p-button label="Вставить данные" (onClick)="onDataInsert($event)" class="mt-2 mb-2 mr-2" severity="help" [disabled]="!canInsertData"></p-button>
          </div>
        </p-accordionTab>

        <p-accordionTab [selected]="openImportResult">
          <ng-template pTemplate="header">
            <h5>Импорт данных</h5>
          </ng-template>
          <app-list-product-array appStopAccordionHomeEnd [products]="products" [loading]="saving" [initialColumnSet]="viewColumnSet" state="importProdDlgState"></app-list-product-array>
        </p-accordionTab>

      </p-accordion>

    </div>

  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (onClick)="onImportContent('ok')" [disabled]="notReady"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (onClick)="display=false"></p-button>
  </ng-template>
</p-dialog>
